import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { lawyersListUrl } from "../lawyers/lawyerHelpers";
import { questionsUrl } from "../questions/questionHelpers";
import "./contact.css";
import { currentLang } from "../../shared/seo/links";

const CONTACT_EMAIL = "contact@avoconsulte.com";

// Side panel of the contact page: the team's email, and shortcuts for
// visitors who are really looking for a lawyer or a legal answer.
export default function InfoSection() {
  const { t } = useTranslation();
  const Lng = currentLang();
  const arrow = Lng === "ar" ? "fas fa-arrow-left" : "fas fa-arrow-right";

  return (
    <div className="avc-contact-aside">
      <a href={"mailto:" + CONTACT_EMAIL} className="avc-contact-tile">
        <span className="avc-contact-tile__icon">
          <i className="far fa-envelope" aria-hidden="true"></i>
        </span>
        <span className="avc-contact-tile__body">
          <strong>{t("contact_email_title")}</strong>
          <span dir="ltr">{CONTACT_EMAIL}</span>
        </span>
      </a>
      <Link to={lawyersListUrl(Lng)} className="avc-contact-tile">
        <span className="avc-contact-tile__icon">
          <i className="fas fa-balance-scale" aria-hidden="true"></i>
        </span>
        <span className="avc-contact-tile__body">
          <strong>{t("contact_find_lawyer_title")}</strong>
          <span>{t("contact_find_lawyer_text")}</span>
        </span>
        <i className={arrow + " avc-contact-tile__arrow"} aria-hidden="true"></i>
      </Link>
      <Link to={questionsUrl(Lng)} className="avc-contact-tile">
        <span className="avc-contact-tile__icon">
          <i className="far fa-comments" aria-hidden="true"></i>
        </span>
        <span className="avc-contact-tile__body">
          <strong>{t("contact_question_title")}</strong>
          <span>{t("contact_question_text")}</span>
        </span>
        <i className={arrow + " avc-contact-tile__arrow"} aria-hidden="true"></i>
      </Link>
    </div>
  );
}
